import { createSlice } from '@reduxjs/toolkit'

function readFeatureIndex() {
  const raw =
    localStorage.getItem("featureIndex") ??
    localStorage.getItem("feartureIndex");
  const index = Number.parseInt(raw, 10);
  return Number.isFinite(index) && index >= 0 ? index : 0;
}

export const featureSlice = createSlice({
  name: 'feature',
  initialState: {
    value: {
      index: readFeatureIndex()
    },
  },
  reducers: {
    changeIndex: (state, action) => {
      const { index } = action.payload
      state.value = {
        index: index
      }
    },
  },
})

export const { changeIndex } = featureSlice.actions

export default featureSlice.reducer